import React from 'react';
import './newHero.css'
import fingers from '../assets/branding/2fingers.png'

const NewHero = () => {
    return (
        <div className='hero'>
            <div>
                <h2>Bastard Cards</h2>
                <p>Home of the emotionally inept and sentimentally clumsy</p>
            </div>
            {/* <h3>home of the emotionally inept and the sentimentally clumsy</h3> */}
            <img src={fingers} className='hand-icon' alt="" />
        </div>
    )
}

export default NewHero